import { Box } from "@mui/material";
import dayjs from "dayjs";
import { formatAddress } from "../../../helpers/helper";
import { dateFormatWithTimeWithoutA } from "../../../constants";
import "./style.css";

export const NotificationItem = ({ notification }) => {
    const date = dayjs(notification?.createdAt).format(dateFormatWithTimeWithoutA);

    if (notification?.notificationTypeId === 20) {
        return (
            <Box className="notification-item">
                <Box className="notification-item-date">{date}</Box>
                <Box className="notification-item__text">Объект: {notification?.facilityName}</Box>
                <Box className="notification-item__text">
                    Номер интеграционного объекта: {notification?.protectionObjectNumber}
                </Box>
                <Box className="notification-item__text">Не на связи: {notification?.noLinkTime} минут</Box>
            </Box>
        );
    }

    return (
        <Box className="notification-item">
            <Box className="notification-item-date">{date}</Box>
            <Box className="notification-item__text">{notification?.facilityName}</Box>
            <Box className="notification-item__text">{formatAddress(notification?.facilityAddress)}</Box>
            {notification?.controlConsoleName && (
                <Box className="notification-item__text">{notification?.controlConsoleName}</Box>
            )}
            <Box className="notification-item__text">Пульт не на связи.</Box>
        </Box>
    );
};
